import { Fragment } from 'react';

import { Layouts } from '~/shared';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.DefaultNight} />
		)}
		<StyledBackground className={`${Layouts.Tablet}-background`} />
	</Fragment>
);

export { Background };
